import React from 'react';
import PropTypes from 'prop-types';
import NavBarMobile from './Mobile';
import NavBarDesktop from './Desktop';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';

const NavBar = ({ mediaIsPhone, mediaIsTablet, isLogged }) => {
  if (mediaIsPhone || mediaIsTablet) {
    return <NavBarMobile isLogged={isLogged} />;
  }
  return <NavBarDesktop isLogged={isLogged} />;
};

NavBar.propTypes = {
  isLogged: PropTypes.bool,
  // HOC withMediaQueries
  mediaIsPhone: PropTypes.bool.isRequired,
  mediaIsTablet: PropTypes.bool.isRequired,
};

export default withMediaQueries(NavBar);
